export const CALL_BUTTON_CSS = /* css */ `
  /* ── Call button — circle (inactive) ── */
  .lk-widget-call-btn {
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%; border: none;
    background: var(--wg-accent-dark); color: white; cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease;
  }
  .lk-widget-call-btn:hover:not(:disabled) { background: var(--wg-accent); transform: scale(1.05); }
  .lk-widget-call-btn:active:not(:disabled) { transform: scale(0.96); }
  .lk-widget-call-btn:disabled { cursor: default; opacity: 0.85; }
  .lk-widget-call-btn--sm { width: 40px; height: 40px; }
  .lk-widget-call-btn--sm svg { width: 13px; height: 13px; }
  .lk-widget-call-btn--lg {
    width: 48px; height: 48px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.18), 0 0 0 4px var(--wg-bg);
  }
  .lk-widget-call-btn--lg svg { width: 22px; height: 22px; }

  /* ── Call pill — orange pill (active voice mode) ── */
  .lk-widget-call-pill {
    display: flex; align-items: center; gap: 6px;
    height: 40px; padding: 0 14px;
    border-radius: 9999px; border: none;
    background: var(--wg-clay); color: white; cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;
  }
  .lk-widget-call-pill svg { width: 14px; height: 14px; flex-shrink: 0; }
  .lk-widget-call-pill:hover:not(:disabled) { opacity: 0.9; transform: scale(1.03); }
  .lk-widget-call-pill:active:not(:disabled) { transform: scale(0.97); }
  .lk-widget-call-pill:disabled { cursor: default; opacity: 0.85; }
  .lk-widget-call-pill--connecting { opacity: 0.85; }

  /* Visualizer bars inside the pill */
  .lk-widget-call-pill-visualizer {
    width: 36px; height: 18px;
    display: flex; align-items: center;
  }
  .lk-widget-call-pill-visualizer .lk-audio-bar-visualizer {
    gap: 2px;
  }
  .lk-widget-call-pill-visualizer .lk-audio-bar {
    width: 3px; border-radius: 1.5px;
    background: rgba(255,255,255,0.6);
  }
  .lk-widget-call-pill-visualizer .lk-audio-bar.lk-highlighted {
    background: white;
  }

  .lk-widget-spinner { animation: lk-widget-spin 0.9s linear infinite; }
  @keyframes lk-widget-spin { to { transform: rotate(360deg); } }
`;
